export default {
    // 首页的下载资料
    secSignSoftware: "http://oss.aliyuncs.com/hymake-nova-download/SecSealCptV7.1(vs2010_zxb)_Build2009_2217.exe",
    secSignIntro: "http://hymake-nova-download.oss-cn-hangzhou.aliyuncs.com/电子签章操作手册.doc",
    secSignDoc: "http://hymake-nova-download.oss-cn-hangzhou.aliyuncs.com/智慧服务平台使用的正确姿势.docx",
    settlement: "http://hymake-nova-download.oss-cn-hangzhou.aliyuncs.com/结算信息填报有关事项2016_5.doc",
    helpTel: "http://hymake-nova-download.oss-cn-hangzhou.aliyuncs.com/合同履约评价机构咨询电话.xls",
    resetSecSign: "http://hymake-nova-download.oss-cn-hangzhou.aliyuncs.com/如何正确卸载重装凯特信安.docx",
    // 月考评登记
}



// WEBPACK FOOTER //
// ./src/api/staticFile.js